import React from 'react';
import { Route, Switch } from 'react-router';

import ProductDetail from './ProductDetail';
import ProductList from './ProductList/ProductList';

export default function Products() {
  return (
    <Switch>
      <Route path="/products/:id" component={ProductDetail} />
      <Route path="/products" component={ProductList} />
    </Switch>
  );
}
